// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

/**
 * Activity Log API Client
 *
 * Bulk-dismiss endpoint for alerts surfaced in the Activity Log
 * (and the dashboard "Alerts & Insights" panel). Alerts live in the
 * Alerts & Insights Service and are dismissed via /api/alerts/bulk-dismiss
 * (idempotent — re-dismissing an already-dismissed alert is a no-op).
 *
 * Insights are NOT dismissable today: there is no insight generator yet,
 * so there is nothing for an advisor to dismiss. When generation lands the
 * dismissal endpoint can be added alongside it (in the alerts-service, to
 * stay consistent with the alerts pattern).
 */

import api from './advisorApi';

export interface BulkDismissResponse {
  dismissedCount: number;
}

export const activityLogApi = {
  dismissAlerts: async (ids: string[]): Promise<BulkDismissResponse> => {
    if (ids.length === 0) {
      return { dismissedCount: 0 };
    }
    const response = await api.post<BulkDismissResponse>('/alerts/bulk-dismiss', { ids });
    return response.data;
  },
};

export default activityLogApi;
